import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { Likes } from '@widgets/likes/Likes';

export const Route = createFileRoute('/likes')({
  component: Component,
});

export default function Component() {
  return (
    <Page>
      <Likes />
    </Page>
  );
}
